var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsBookmarkOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 19.057V5a1 1 0 00-1-1H7a1 1 0 00-1 1v14.057l5.419-3.87a.994.994 0 011.162 0L18 19.056zm-6-1.828l-6.419 4.585A1 1 0 014 21V5a3 3 0 013-3h10a3 3 0 013 3v16a1 1 0 01-1.581.814L12 17.229z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMTggMTkuMDU3VjVjMC0uNTUyLS40NDgtMS0xLTFIN2MtLjU1MiAwLTEgLjQ0OC0xIDF2MTQuMDU3bDUuNDE5LTMuODdjLjM0Ny0uMjUuODE1LS4yNSAxLjE2MiAwTDE4IDE5LjA1NnptLTYtMS44MjhsLTYuNDE5IDQuNTg1QzQuOTIgMjIuMjg2IDQgMjEuODE0IDQgMjFWNWMwLTEuNjU3IDEuMzQzLTMgMy0zaDEwYzEuNjU3IDAgMyAxLjM0MyAzIDN2MTZjMCAuODEzLS45MiAxLjI4Ni0xLjU4MS44MTRMMTIgMTcuMjI5eiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconsBookmarkOutlined as ReactComponent };